import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreferenzaAgenzia } from '../models/preferenza-agenzia';
import { ResourcefulService } from './resourcefulService';

@Injectable({
  providedIn: 'root'
})
export class PreferenzaAgenziaService extends ResourcefulService<PreferenzaAgenzia>{

  constructor(httpClient: HttpClient) {
    super(httpClient, PreferenzaAgenzia);
  }
}
